import { MegaraxUri } from "../uri";
import { LegacyRedirect, redirect } from "./redirect";

const polishRedirects: LegacyRedirect[] = [
  redirect("/specjalista/qr-sync/line/:lineId", ({ lineId }) =>
    MegaraxUri("megarax://loyalty/lines/id/{id}", { id: lineId }),
  ),
  redirect("/specjalista/qr-sync", () => MegaraxUri("megarax://loyalty/lines")),
  redirect("/specjalista/batches/ungroup-code", () => MegaraxUri("megarax://loyalty/ungroup-code")),
  redirect("/specjalista/batches/label-batch/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/label-batches/id/{id}", { id: groupName }),
  ),
  redirect("/specjalista/batches/production-batch/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/production-batches/id/{id}", { id: groupName }),
  ),
  redirect("/specjalista/batches/*", () => MegaraxUri("megarax://loyalty/batches")),
  redirect("/specjalista/product-codes/groups/*", () => MegaraxUri("megarax://loyalty/code-groups")),
  redirect("/specjalista/product-codes/inspect-code/:codeId", ({ codeId }) =>
    MegaraxUri("megarax://loyalty/inspect-code/id/{id}", { id: codeId }),
  ),
  redirect("/specjalista/product-codes/inspect-code", () => MegaraxUri("megarax://loyalty/inspect-code")),
  redirect("/specjalista/listings/*", () => MegaraxUri("megarax://loyalty/listings")),
  redirect("/specjalista/order-fulfillment/id/:orderId", ({ orderId }) =>
    MegaraxUri("megarax://fulfillment/orders/id/{id}", { id: orderId }),
  ),
  redirect("/specjalista/order-fulfillment", () => MegaraxUri("megarax://fulfillment/orders")),
  redirect("/specjalista/carts/id/:cartId", ({ cartId }) => MegaraxUri("megarax://loyalty/carts/id/{id}", { id: cartId })),
  redirect("/specjalista/carts", () => MegaraxUri("megarax://loyalty/carts")),
  redirect("/specjalista/blik-checks", () => MegaraxUri("megarax://loyalty/blik-checks")),
  redirect("/specjalista/accounts/id/:userId", ({ userId }) =>
    MegaraxUri("megarax://loyalty/accounts/id/{id}", { id: userId }),
  ),
  redirect("/specjalista/accounts", () => MegaraxUri("megarax://loyalty/accounts")),
  redirect("/specjalista", () => MegaraxUri("megarax://loyalty/lines")),
];

export const loyaltyRedirects: LegacyRedirect[] = [
  ...polishRedirects,

  redirect("/loyalty/qr-sync/lines/id/:lineId", ({ lineId }) =>
    MegaraxUri("megarax://loyalty/lines/id/{id}", { id: lineId }),
  ),
  redirect("/loyalty/qr-sync/line/:lineId", ({ lineId }) => MegaraxUri("megarax://loyalty/lines/id/{id}", { id: lineId })),
  redirect("/loyalty/qr-sync", () => MegaraxUri("megarax://loyalty/lines")),

  redirect("/loyalty/batches/ungroup-code", () => MegaraxUri("megarax://loyalty/ungroup-code")),
  redirect("/loyalty/batches/label-batches/id/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/label-batches/id/{id}", { id: groupName }),
  ),
  redirect("/loyalty/batches/label-batch/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/label-batches/id/{id}", { id: groupName }),
  ),
  redirect("/loyalty/batches/production-batches/id/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/production-batches/id/{id}", { id: groupName }),
  ),
  redirect("/loyalty/batches/production-batch/:groupName", ({ groupName }) =>
    MegaraxUri("megarax://loyalty/production-batches/id/{id}", { id: groupName }),
  ),

  redirect("/loyalty/product-codes/groups/*", () => MegaraxUri("megarax://loyalty/code-groups")),
  redirect("/loyalty/product-codes/inspect-code/:codeId", ({ codeId }) =>
    MegaraxUri("megarax://loyalty/inspect-code/id/{id}", { id: codeId }),
  ),
  redirect("/loyalty/product-codes/inspect-code", () => MegaraxUri("megarax://loyalty/inspect-code")),
  redirect("/loyalty/product-codes/id/:codeId", ({ codeId }) =>
    MegaraxUri("megarax://loyalty/inspect-code/id/{id}", { id: codeId }),
  ),

  redirect("/loyalty/order-fulfillment/id/:orderId", ({ orderId }) =>
    MegaraxUri("megarax://fulfillment/orders/id/{id}", { id: orderId }),
  ),
  redirect("/loyalty/order-fulfillment", () => MegaraxUri("megarax://fulfillment/orders")),
];
